<template>
	<bar 
	ref="chart"
	:height="height"
	:chart-data="data" 
	:plugins="plugins"
	:chart-options="options" />
</template>

<script> 

	import { Bar } from 'vue-chartjs/legacy'

	import { 
		Chart as ChartJS, 
		Title, 
		Tooltip, 
		Legend, 
		BarElement, 
		CategoryScale, 
		LinearScale 
	} from 'chart.js'

	import ChartDataLabels from 'chartjs-plugin-datalabels'

	ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ChartDataLabels)

	export default { 

		props: {

			height: {
				type: Number,
				default: 250
			},

			chartData: {
				type: Object,
				default: () => {}
			}, 

			plugins: {
				type: Array,
				default: () => []
			},

			options: {
				type: Object,
				default: () => {}
			}

		},

		components: {
			Bar,
		},

		computed: {
			data() {
				return this.chartData ? this.chartData : {}
			}
		}

	}

</script> 